<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{}">
      <BaseButton
        @click="openModal"
        :text="
          type === 'responsible'
            ? localStorage.translations.pages.sales_project[
                'planned_resources-responsible_employees-buttons'
              ]['dobavit-otvetstvennoe-litso']
            : localStorage.translations.pages['sales_project']['planned_resources-subscribers']
                .add_project
        "
        reverse
        default_icon="button-add"
        :disabled="type === 'responsible' && workClientProjectsResponsibleEmployeesAll_project.length > 0"
        v-show="!(type === 'responsible' && workClientProjectsResponsibleEmployeesAll_project.length > 0)"
      />
    </template>
    <transition :duration="150">
      <div class="edit">
        <CloseModalBtn :closeModal="closeModal" />
        <h5>
          {{
            type === 'responsible'
              ? localStorage.translations.pages.sales_project['planned_resources-responsible_employees']['dobavlenie-otvetstvennogo-litsa']
              : localStorage.translations.pages['sales_project']['planned_resources-subscribers'].add_project
          }}
        </h5>
        <v-form ref="form" lazy-validation v-model="valid" @submit.prevent="onCreate">
          <BaseInput
            v-if="type === 'responsible'"
            v-model="employee_id"
            :label="localStorage.translations.pages.sales_project['planned_resources-responsible_employees-labels']['sotrudnik']"
            type="autocomplete"
            :items="resplonsibleEmployeeReady"
            item-value="id"
            :item-text="(i) => i.user.first_name + ' ' + i.user.last_name"
            :rules="['required']"
            :disabled="resplonsibleEmployeeReady.length === 0"
          />
          <BaseInput
            v-if="type === 'responsible'"
            v-model="hour_salary"
            placeholder="—"
            input-type="number"
            :label="localStorage.translations.pages.sales_project['planned_resources-labels']['hourly_premium']"
            :rules="['required']"
            @input="onlyNumbers($event, 'hour_salary')"
          />
          <BaseInput
            v-if="type === 'responsible'"
            v-model="unit_salary"
            placeholder="—"
            input-type="number"
            :label="localStorage.translations.pages.sales_project['planned_resources-labels']['unit_premium']"
            :rules="['required']"
            @input="onlyNumbers($event, 'unit_salary')"
          />
          <BaseInput
            v-else
            v-model="user_id"
            :label="localStorage.translations.pages['sales_project']['planned_resources-subscribers'].subscriber"
            type="autocomplete"
            :items="subscribersReady"
            item-value="id"
            :item-text="(i) => i.first_name + ' ' + i.last_name"
            :rules="['required']"
            :disabled="subscribersReady.length === 0"
            multiple
            chips
            deletable-chips
          />
          <div class="container_btn">
            <BaseButton
              type="submit"
              :text="
                localStorage.translations.pages.sales_project[
                  'planned_resources-responsible_employees-buttons'
                ]['sohranit']
              "
              default_icon="button-save"
            />
          </div>
        </v-form>
      </div>
    </transition>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CloseModalBtn from 'components/CloseModalBtn'

export default {
  name: 'ProjectPlannedResourcesResponsibleEmployeeAddModal',
  components: { CloseModalBtn },
  props: {
    projectId: [String, Number],
    reverse: Boolean,
    type: String,
  },
  data() {
    return {
      dialog: false,
      valid: true,
      // roles_id: null,
      employee_id: null,
      user_id: null,
      hour_salary: null,
      unit_salary: null,
    }
  },
  computed: {
    ...mapGetters('workClientProjectsResponsibleEmployees', [
      'workClientProjectsResponsibleEmployeesAll_project',
    ]),
    ...mapGetters('workClientProjectsSubscribers', ['workClientProjectsSubscribersAll_project']),
    ...mapGetters('employee', ['employeeAll']),
    ...mapGetters('commonUser', ['commonUserSubscribersAll']),
    ...mapGetters('workClientProject', ['workClientProjectShow']),
    resplonsibleEmployeeReady() {
      let items = this.workClientProjectsResponsibleEmployeesAll_project
      let ids = []
      for (let i = 0; i < items.length; ++i) {
        ids.push(items[i].employee.user.id)
      }
      let result = this.employeeAll.filter((i) =>
        ids.length ? ids.indexOf(i.user.id) === -1 : true,
      )
      return result
    },
    subscribersIds() {
      let items = this.workClientProjectsSubscribersAll_project
      let ids = []
      for (let i = 0; i < items.length; ++i) {
        ids.push(items[i].user.id)
      }
      return ids
    },
    subscribersReady() {
      let result = this.commonUserSubscribersAll.filter((i) =>
        this.subscribersIds.length ? this.subscribersIds.indexOf(i.id) === -1 : true,
      )
      return result
    },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.type === 'responsible' ? this.onEmployeeAll() : this.onCommonUserSubscribersAll()
      }
    },
  },
  methods: {
    ...mapActions('workClientProjectsResponsibleEmployees', [
      'onWorkClientProjectsResponsibleEmployeesGrid',
      'onWorkClientProjectsResponsibleEmployeesUpdate',
      'onWorkClientProjectsResponsibleEmployeesAll_project',
    ]),
    ...mapActions('workClientProjectsSubscribers', [
      'onWorkClientProjectsSubscribersCreate',
      'onWorkClientProjectsSubscribersUpdate',
      'onWorkClientProjectsSubscribersAll_project',
    ]),
    ...mapActions('workClientProject', ['onWorkClientProjectUpdate']),
    ...mapActions('employee', ['onEmployeeAll']),
    ...mapActions('commonUser', ['onCommonUserSubscribersAll']),
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
    validate() {
      this.$refs.form.validate()
    },
    onlyNumbers(event, vModel) {
      let result = event.replace(/[^0-9,.]/g, '').replace(/,/g, '.')
      this[vModel] = parseFloat(result)
    },
    async onCreate() {
      await this.validate()
      if (this.valid === true) {
        let data = {}
        if (this.type === 'responsible') {
          data.project_id = this.projectId
          data.employee_id = this.employee_id
          data.hour_salary = this.hour_salary
          data.unit_salary = this.unit_salary
          
        } else {
          data.id = this.workClientProjectShow.id
          data.subscribers = [...this.subscribersIds, ...this.user_id]
          data.work_client_id = this.workClientProjectShow.work_client.id
          data.name = this.workClientProjectShow.name
          data.business_segment_id = this.workClientProjectShow.business_segment_id
          data.project_type_id = this.workClientProjectShow.project_type_id
          data.start_date = this.workClientProjectShow.start_date
          data.end_date = this.workClientProjectShow.end_date
        }
        ;(this.type === 'responsible'
          ? this.onWorkClientProjectsResponsibleEmployeesUpdate(data)
          : this.onWorkClientProjectUpdate(data)
        )
          // this[
          //     this.type === 'responsible'
          //         ? 'onWorkClientProjectsResponsibleEmployeesCreate'
          //         : 'onWorkClientProjectUpdate'
          // ]({ data })
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common['notifications']['uspeshno-dobavlen'],
                IsError: false,
              },

              { root: true },
            )
            this[
              this.type === 'responsible'
                ? 'onWorkClientProjectsResponsibleEmployeesAll_project'
                : 'onWorkClientProjectsSubscribersAll_project'
            ]({
              project_id: this.$route.params.id,
            })
            this.closeModal()
            this.employee_id = null
            this.user_id = null
          })
          .catch((err) => {
            if (err.response.data.errors) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common['notifications']['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            }
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.edit {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
  text-align: center;
  padding: 60px;
  position: relative;
  .close {
    padding: 16px;
  }

  h5 {
    text-align: center;
    margin-bottom: 50px;
  }
  form {
    text-align: left;
    display: grid;
    grid-column-gap: 30px;
    grid-row-gap: 10px;
    label {
      font-weight: normal;
      font-size: 14px;
      line-height: 26px;
      color: #52525f;
    }

    .v-text-field {
      padding-top: 0px;
      margin-top: 0px;
      fieldset {
        border: 1px solid #b4b4b4;
        border-radius: 4px;
      }
      .theme--light.v-icon {
        color: #b4b4b4;
      }
    }
    .container_btn {
      margin-top: 30px;
      display: grid;
      justify-content: center;
    }
    .v-input--selection-controls {
      margin-top: 0;
    }
  }
}
</style>
